<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <password-find-material @firstCall="firstReceive" @secondCall="secondReceive"></password-find-material>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
  }

  45% {
     transform: scale(1.05);
   }

  80% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes dert2-loader-cycle {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(3600deg);
  }
}

$default-color: #404043;

.normal-font-style {
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
}

.absolute-center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.dert2-container.dert2-shown {
  background-color: rgba(176, 180, 197, 0.4);
}

.dert2-container.dert2-center {
  align-items: center;
}

.dert2-container {
  display: flex;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 10px;
  background-color: transparent;
  z-index: 1060;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

div.dert2-popup {
  width: 230px;
  height: auto;
  min-height: 210px;
  border-radius: 10px;
  box-shadow: 0 3px 14px 0 rgba(176, 180, 197, 0.2);
  padding: 50px 0 34px 0;
  position: relative;
  flex-direction: column;
  justify-content: center;
  width: 14.4em;
  max-width: 100%;
  padding: 1.25em 0em 0em;
  border-radius: 6px;
  background: #fff;
  font-family: inherit;
  font-size: 1rem;
  box-sizing: border-box;

  .contents-container {
    margin: 0;
    min-height: inherit;

    div.login-field {
      position: relative;
      top: inherit;
      left: inherit;
      transform: inherit;

    }
  }

  .dert2-header {
    margin-top: 76px;
  }

  .dert2-icon {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .dert2-title {
      @extend .normal-font-style;
      color: $default-color;
      margin: 0 auto;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-weight: 400;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.5;
      letter-spacing: normal;
      text-align: center;

    }

    .dert2-close {
      color: #000000;
      float: right;
      font-size: 20px;
      border: none;
      cursor: pointer;
      background-color: #FFF;
    }

    .dert2-loader {
      position: relative;
      width: 23px;
      height: 23px;
    }

  }

  .dert2-content {

    font-size: 12px;
    @extend .normal-font-style;
    color: $default-color;
    margin-top: 12px;

    div#dert2-content {
      font-size: 14px;
      @extend .normal-font-style;
      line-height: 1.57;
      letter-spacing: -0.1px;
      color: #242424;
    }

    .dert2-input-box {
      display: flex;
      flex-direction: column;
      margin-top: 24px;

      input.dert2-input {
        max-width: 100%;
        height: 40px;
        padding: 8px;
        padding: 0 12px;
        width: 100%;
        box-sizing: border-box;
        margin: 4px 0;
        background-color: #f8f8fa;
      }

      #dert2-input-label {
        font-size: 14px;
        @extend .normal-font-style;
        color: $default-color;
      }

      #dert2-validationerror {
        font-size: 12px;
        display: none;
        @extend .normal-font-style;
        color: #ff2f4d;
      }
    }
  }

  .dert2-actions {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 0;
    width: 100%;

    button {
      width: 50%;
      height: 48px;
      border: none;
      font-size: 14px;
      font-weight: 500;
      color: #fff;

      &.btn_grey {
        background-color: #707070;
        border-bottom-left-radius: 5px;
      }
      &.btn_red {
        background-color: #ff6565;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
        width: 100%;
      }
    }

  }
}

.dert2-show {
  -webkit-animation: showSweetAlert .3s;
  animation: showSweetAlert .3s;
}

.dert2-copy-clip-box {
  margin-top: 24px;
  width: 100%;

  .dert2-copy-txt-wrap {
    display: flex;
    align-items: center;

    .dert2-copy-txt {
      height: 40px;
      font-size: 12px;
      font-weight: 500;
      @extend .normal-font-style;
      max-width: calc(100% - 36px);
      width: 100%;
      justify-items: center;
      line-height: 40px;
      overflow: hidden;
      letter-spacing: -0.1px;
      color: #242424;
      margin-right: 8px;
      padding-left: 12px;
      border-radius: 4px;
      background-color: #f8f8fa;
      align-items: center;
      cursor: pointer;

      input {
        width: 100%;
        height: 100%;
        border: none;
        background: inherit;
        max-width: 100%;
      }

    }

  }

  .dert2-copy-eye {
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-bottom: 14px;

    span {
      font-size: 14px;
      font-weight: bold;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: -0.1px;
      color: #4eb4ff;
      cursor: pointer;
    }

  }

  img {
    cursor: pointer;
  }
}

.spinner {
  width: 23px;
  height: 23px;
  position: absolute;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: rgba(0, 142, 247, 0.4);;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2.0s infinite ease-in-out;
  animation: sk-bounce 2.0s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1.0s;
  animation-delay: -1.0s;
}

@-webkit-keyframes sk-bounce {
  0% {
    -webkit-transform: scale(0.0)
  }

  100% {
    -webkit-transform: scale(1.0)
  }
}

@keyframes sk-bounce {
  0% {
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  }

  100% {
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}

@keyframes hideSweetAlert {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

</style>
<script>
import AppHeader from '../components/AppHeader'
import AppSidebar from '../components/AppSidebar'
import TrackingProgress from '../components/TrackingProgress'
import passwordFindMaterial from '../components/passwordFindMaterial'

export default {
  data () {
    return {
      transDate: {
        headerName: '비밀번호 찾기',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/'
      }
    }
  },
  components: {
    AppHeader,
    TrackingProgress,
    passwordFindMaterial,
    AppSidebar
  },
  methods: {
    firstReceive () {
      this.$refs.progress.chapter1()
    },
    secondReceive () {
      this.$refs.progress.chapter2()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
